import { render, staticRenderFns } from "./SubCategoryValue.vue?vue&type=template&id=3b07e2d6&scoped=true"
import script from "./SubCategoryValue.vue?vue&type=script&lang=js"
export * from "./SubCategoryValue.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryValue.vue?vue&type=style&index=0&id=3b07e2d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07e2d6",
  null
  
)

export default component.exports